import React from "react";
import shareBird from "../assets/thanksbtn.png";
import shareIcon from "../assets/share.png";

const Share = (props) => {
  const { setIsOpen, setShareModelOpen, pauseAllMedia } = props;

  const handleSeeMoreClick = () => {
    if (pauseAllMedia) {
      pauseAllMedia();
    }
  };

  return (
    <div className="share-container">
      {/* 1. Say Thanks Card */}
      <div className="share-btn-card" onClick={() => setIsOpen(true)}>
        <div className="share-btn-inner">
          <img src={shareBird} alt="Say Thanks" className="share-card-bird" />
          <span style={{
            fontSize: "12px"
          }} className="share-card-title purple">Say <br /> Thanks</span>
        </div>
      </div>

      {/* 2. Share Card */}
      <div className="share-btn-card" onClick={() => setShareModelOpen(true)}>
        <div className="share-btn-inner">
          <img src={shareIcon} alt="Share" className="share-card-icon" />
          <span style={{
            fontSize: "12px"
          }} className="share-card-title purple">Share</span>
        </div>
      </div>

      {/* 3. See More + Create a JiveBird Card */}
      {/*Test Test Test Test Test Test*/}
      <a
        href="https://jivebird.com"
        target="_blank"
        rel="noopener noreferrer"
        className="share-btn-card share-btn-link"
        onClick={handleSeeMoreClick}
      >
        <div className="share-btn-inner-see">
          <span style={{
            fontSize: "12px"
          }} className="share-card-create-text">
            See More
            <br />
            + <br />Create
            a <br />JiveBird
          </span>
        </div>
      </a>
    </div>
  );
};

export default Share;